module.exports = __webpack_public_path__ + "static/party-526ccf7986552607ef8f6396cb6b713b.png";